import * as Sentry from "@sentry/react";

// Initialize Sentry for production error monitoring
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Performance monitoring
    tracesSampleRate: 0.1,
    // Session replay for debugging
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Environment
    environment: import.meta.env.MODE,
    beforeSend(event) {
      // Filter out non-critical errors
      if (event.exception) {
        const error = event.exception.values?.[0];
        if (error?.type === 'ChunkLoadError' || error?.value?.includes('Loading chunk')) {
          return null; // Don't send chunk loading errors
        }
      }
      return event;
    },
  });
}

export { Sentry };